import { httpClientV2, httpClientOS } from '@/services/httpClient';

export function unwrapV2(newPromise, client = httpClientV2) {
  return new Promise((resolve, reject) => {
    Promise.resolve(client)
      .then(newPromise)
      .then(
        (response) => resolve(response?.data ?? response),
        (error) => reject(error?.response?.data ?? error?.response ?? error)
      );
  });
}

// project intake uses v2 api due to Commercie rol in new RBAC system (OS)
export const fetchProjectV2 = (projectId) =>
  unwrapV2((axios) => axios.get(`projects/${projectId}`));
export const createProjectV2 = (data) =>
  unwrapV2((axios) => axios.post(`projects`, data));

export const createProjectOS = (data) =>
  unwrapV2((axios) => axios.post(`projects`, data), httpClientOS);

// { template: null | { run_id, status: pending|running|completed|failed, error } }
export const fetchProjectSetupOS = (projectId) =>
  unwrapV2((axios) => axios.get(`projects/${projectId}/setup`), httpClientOS);
// Queues a failed template again; answers with the setup status.
export const retryProjectSetupOS = (projectId) =>
  unwrapV2(
    (axios) => axios.post(`projects/${projectId}/setup/retry`),
    httpClientOS
  );

export const fetchProjectRolesOS = (projectId) =>
  unwrapV2(
    (axios) => axios.get(`/rbac/projects/${projectId}/roles`),
    httpClientOS
  );
export const addUserRoleOS = (userId, roleId) =>
  unwrapV2(
    (axios) => axios.post(`/rbac/users/${userId}/roles/${roleId}`),
    httpClientOS
  );
export const removeUserRoleOS = (userId, roleId) =>
  unwrapV2(
    (axios) => axios.delete(`/rbac/users/${userId}/roles/${roleId}`),
    httpClientOS
  );
export const updateProjectV2 = (projectId, data) =>
  unwrapV2((axios) => axios.put(`projects/${projectId}`, data));

// The below api calls need to both check old and new RBAC roles in backend
export const queryTablesV2 = (data) =>
  unwrapV2((axios) => axios.post(`/tables/query`, data));
export const importTasksV2 = (data) =>
  unwrapV2((axios) => axios.post(`/tasks`, data));

/* IMPORTANT!!!! DO NOT ADD MORE V2 API CALLS TO LAUNCHER. V1 (Launcher) and V2 (OS)
need to be fully seperated permission wise except for the above api calls*/
